import {
  Box,
  Divider,
  styled,
  TableContainer,
  TextField,
  Typography,
} from '@mui/material';
import { Button } from '../../../components';

export const StyledTypography = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(1),
}));

export const InfoTypography = styled(Typography)(({ theme }) => ({
  fontSize: '0.75rem',
  lineHeight: '1rem',
  marginBottom: '2px',
  fontStyle: 'italic',
  color: theme.palette.text.tertiary,
  marginTop: 0,
}));

export const InfoBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '-30px',
  left: 0,
  width: '100%',
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius,
}));

export const StyledBox = styled(Box)(({ theme }) => ({
  position: 'relative',
}));

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  maxHeight: 200,
  overflowY: 'auto',
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[1],
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

export const WideModalWrapper = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80vw',
  maxWidth: '1200px',
  maxHeight: '90vh',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: '16px',
  backgroundColor: theme.palette.background.paper,
  boxShadow: theme.shadows[24],
  padding: theme.spacing(4),
  overflow: 'hidden',
}));

export const ScrollableContent = styled(Box)({
  overflowY: 'auto',
  overflowX: 'hidden',
  flex: 1,
});

export const NotesContainer = styled(Box)(({ theme }) => ({
  padding: '6px',
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
}));

export const SectionDivider = styled(Divider)(({ theme }) => ({
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(1),
}));
